const upperCaseArray = (arrayOfStrings: string[]) =>
  arrayOfStrings.map((string) => string[0].toUpperCase() + string.slice(1));

export const titleize = (string: string) =>
  upperCaseArray(string.split(' ')).join(' ');
